import type { WeeklyPlanExecutionMode, WeeklyPlanStatus } from "../../../shared/weekly-planning";

const number = new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2 });

export function WeeklyPlanningWorkflowStatus(props: {
  status: WeeklyPlanStatus;
  executionMode: WeeklyPlanExecutionMode;
  busy: boolean;
  dirty: boolean;
  totalHours: number;
}) {
  if (props.status === "ACTIVE") return <>Etkin plan salt okunur.</>;
  if (props.busy) return <>İşlem sürüyor…</>;
  if (!props.dirty) return props.executionMode === "OPERATOR_SELECTED"
    ? <>Saat planı kullanılmıyor; doğrulanan işler operatör seçimine hazır.</>
    : <>{number.format(props.totalHours)} saat planlandı.</>;
  return props.executionMode === "OPERATOR_SELECTED"
    ? <>Taslak değişti; kaydedince Mikro&apos;da doğrulanan işler operatör seçimine hazırlanır.</>
    : <>Taslak değişti; kaydedince kapasite ve saatler sunucuda yeniden hesaplanır.</>;
}
